exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kontakt-js": () => import("./../../../src/pages/kontakt.js" /* webpackChunkName: "component---src-pages-kontakt-js" */),
  "component---src-pages-kopie-0-qfjt-8-j-4-gk-88-js": () => import("./../../../src/pages/-Kopie-0qfjt8j4gk88.js" /* webpackChunkName: "component---src-pages-kopie-0-qfjt-8-j-4-gk-88-js" */)
}

